import { render, staticRenderFns } from "./ManageRingbaApiToken.vue?vue&type=template&id=702ab456&scoped=true"
import script from "./ManageRingbaApiToken.vue?vue&type=script&lang=js"
export * from "./ManageRingbaApiToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ab456",
  null
  
)

export default component.exports